import { render } from "./ForEachPropsCmp.vue?vue&type=template&id=98baf8f8"
import script from "./ForEachPropsCmp.vue?vue&type=script&lang=js"
export * from "./ForEachPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__